import UpdateEvaluacionAnualAdapter from './adapters/UpdateEvaluacionAnualAdapter'

class UpdateEvaluacionAnual {
  #repository

  constructor(repository) {
    this.#repository = repository
  }

  async execute({
    idEvaluacionAnual,
    idPersonalEvaluado,
    idPersonalEvaluador,
    idSupervisor,
    estatus,
    fecha,
    tipoEvaluacion,
    reactivos,
  }) {
    const payload = UpdateEvaluacionAnualAdapter.toDto({
      idPersonalEvaluador,
      idSupervisor,
      estatus,
      fecha,
      reactivos,
      tipoEvaluacion,
    })

    return this.#repository.update(idPersonalEvaluado, idEvaluacionAnual, payload)
  }
}

export default UpdateEvaluacionAnual
